import { useState, useEffect } from 'react';
import { LayoutDashboard, Package, CalendarCheck, ClipboardList, Truck, DollarSign, Store, FileText, MessageSquare, Settings, Lock } from 'lucide-react';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { PortalLayout } from '@/components/portal/PortalLayout';
import ApplicationStatus from './ApplicationStatus';
import CompletePasswordSetup from './CompletePasswordSetup';

const NAV = [
  { to: '/farm/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/farm/products', label: 'Products', icon: Package },
  { to: '/farm/availability', label: 'Availability', icon: CalendarCheck },
  { to: '/farm/orders', label: 'FarmBox Orders', icon: ClipboardList },
  { to: '/farm/pickups', label: 'Pickup Schedule', icon: Truck },
  { to: '/farm/payments', label: 'Payments', icon: DollarSign },
  { to: '/farm/profile', label: 'Farm Profile', icon: Store },
  { to: '/farm/payout-info', label: 'Payout Info', icon: Lock },
  { to: '/farm/documents', label: 'Documents', icon: FileText },
  { to: '/farm/messages', label: 'Messages', icon: MessageSquare },
  { to: '/farm/settings', label: 'Settings', icon: Settings },
];

const APPROVED = ['Approved', 'Approved With Conditions'];

export default function FarmPortal() {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.password_setup_complete === false) return;
    setLoading(true);
    api.get('/farm/application').then((r) => setStatus(r.data.status)).catch(() => setStatus('unknown')).finally(() => setLoading(false));
  }, [user?.password_setup_complete]);

  if (user?.password_setup_complete === false) return <CompletePasswordSetup />;

  if (loading) return <div className="min-h-screen bg-cream flex items-center justify-center"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-forest" /></div>;

  if (!APPROVED.includes(status)) return <ApplicationStatus />;

  return <PortalLayout title="Farm Partner" subtitle="Partner Portal" navItems={NAV} homeLink="/" />;
}
